import script from "./SimpleCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleCell.vue?vue&type=script&setup=true&lang=ts"

import "./SimpleCell.vue?vue&type=style&index=0&id=795f9476&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-795f9476"]])

export default __exports__